import { ImportType } from 'src/app/base/models/models.swagger.generated';
import { FieldAssignmentDefinitionsService } from './field-assignment-definitions.service';
import { ValidatorFn, AbstractControl } from '@angular/forms';
import { IImportConfigurationFieldAssignmentExtendedDTO } from './import-configuration-edit-forms/configuration-form-file/configuration-field-assignment-extended-dto';

export class FieldAssignmentsValidator {

  public static fieldAssignmentsValidator(fieldAssignmentDefinitionsService: FieldAssignmentDefinitionsService, importType: ImportType): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const fieldAssignments: IImportConfigurationFieldAssignmentExtendedDTO[] = control.value;
      const targetDefinitions = fieldAssignmentDefinitionsService.getTargetDefinitionsImmediately(importType);
      const functionDefinitions = fieldAssignmentDefinitionsService.getFunctionDefinitionsImmediately(importType);

      fieldAssignments?.forEach(fa => {
        var targetDefinition = targetDefinitions.find(td => td.targetName === fa.targetName);
        var functionDefinition = functionDefinitions.find(fd => fd.importFunction === fa.importFunction);
        if (targetDefinition == null) {
          // target definition not found -> can happen, when a target is removed from the definition list
          fa.valid = false;
          return;
        }
        fa.valid = fa.fixValue != null ||
          (fa.importFunction != null && fieldAssignmentDefinitionsService.isStaticFunction(fa.importFunction)) ||
          (fa.sourceElementName != null && (
            fa.importFunction == null || (targetDefinition.supportedFunctions.some(sf => sf == fa.importFunction) &&
              (functionDefinition?.parameter1?.isMandatory ? fa.functionParameter1Value != null : true) &&
              (functionDefinition?.parameter2?.isMandatory ? fa.functionParameter2Value != null : true) &&
              (functionDefinition?.parameter3?.isMandatory ? fa.functionParameter3Value != null : true) &&
              (functionDefinition?.parameter4?.isMandatory ? fa.functionParameter4Value != null : true) &&
              (functionDefinition?.parameter5?.isMandatory ? fa.functionParameter5Value != null : true))));
      });
      return !fieldAssignments?.every(fa => fa.valid) ? { isfieldAssignmentsInvalid: true } : null;
    };
  }

}
